import { useRef } from "react"
import { useIsoLayoutEffect } from "shared/lib/react/useIsoLayoutEffect"

/**
 * Creates a reference to a value. The reference will always point to the latest value. Can be used to avoid stale closures.
 *
 * @template T - The type of the value.
 * @param value - The current value.
 * @returns A reference to the value.
 */
export function useValueRef<T>(value: T) {
  const ref = useRef(value)

  useIsoLayoutEffect(() => {
    ref.current = value
  }, [value])

  return ref
}
